export default "__VITE_ASSET__ul0OftI9__"